import React from "react";
import "./chip.scss";
import { Tooltip } from "@SeemplicityDev/shared";

export interface ChipProps {
  rightIcon?: string;
  leftIcon?: string;
  text?: string;
  disabled?: boolean;
  small?: boolean;
  square?: boolean;
  noMargin?: boolean;
  noHover?: boolean;
  empty?: boolean;
  tooltipContent?: string;
}

const Chip: React.FC<ChipProps> = ({
  rightIcon,
  leftIcon,
  text,
  disabled,
  small,
  square,
  noMargin,
  noHover,
  empty,
  tooltipContent,
}) => {
  return (
    <Tooltip content={tooltipContent || text}>
      <div
        className={`chip ${disabled ? " is-disabled" : ""} ${
          small ? " is-small" : ""
        } ${square ? "is-square" : ""} ${noMargin ? "has-no-margin" : ""} ${
          noHover ? "has-no-hover" : ""
        } ${empty ? "is-empty" : ""}`}
        data-testid="chip"
      >
        {leftIcon && (
          <i className={`chip-icon icon-left seem-icon ${leftIcon}`} />
        )}
        <span>{text}</span>
        {rightIcon && (
          <i className={`chip-icon icon-right seem-icon ${rightIcon}`} />
        )}
      </div>
    </Tooltip>
  );
};

export default Chip;
